{
  "title": "Valkompassen för Djurens Rätt 2026",
  "questions": [
    {
      "id": 1,
      "slug": "forbjud-turbokycklingarna",
      "image": "/images/questions/Kycklingar_hemsk_34.jpg",
      "title": "Förbjud turbokycklingarna",
      "description": "Kycklingar är de landlevande djur som är flest och har det sämst. Ungefär 99 procent av alla kycklingar som föds upp i Sverige är turbokycklingar. De är dömda till ett liv av lidande där de tvingas att växa så snabbt att de får ont och svårt att röra sig, samt får fler sjukdomar och högre dödlighet än andra kycklingraser. Under deras 35 dagar i livet förväntas de växa från 40 gram till två kilo. Uppfödningen av turbokycklingar är inte förenlig med djurskyddslagen.",
      "proposal": "Förbjud och fasa ut uppfödningen av snabbväxande turbokycklingar i Sverige.",
      "options": [
        {
          "label": "Ja",
          "value": "ja"
        },
        {
          "label": "Nej",
          "value": "nej"
        },
        {
          "label": "Vet ej",
          "value": "vet-ej"
        }
      ],
      "partyAnswers": {
        "socialdemokraterna": {
          "answer": "nej",
          "motivation": ""
        },
        "moderaterna": {
          "answer": "nej",
          "motivation": ""
        },
        "sverigedemokraterna": {
          "answer": "nej",
          "motivation": ""
        },
        "miljopartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "centerpartiet": {
          "answer": "nej",
          "motivation": ""
        },
        "vansterpartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "liberalerna": {
          "answer": "ja",
          "motivation": ""
        },
        "kristdemokraterna": {
          "answer": "nej",
          "motivation": ""
        }
      }
    },
    {
      "id": 2,
      "slug": "stoppa-burarna",
      "image": "/images/questions/honor_hemsk_5.jpg",
      "title": "Stoppa burarna",
      "description": "Idag hålls inga hönor i bur i Sverige men utan ett förbud i lagen finns det en risk att burhållning av hönor återkommer. Burhållningen har stora djurvälfärdsbrister. Hönor i bur kan inte utföra naturliga beteenden som att sträcka på vingarna, picka, sandbada eller dra sig undan för att kunna lägga sina ägg i fred.",
      "proposal": "Förbjud burhållning av hönor i Sverige.",
      "options": [
        {
          "label": "Ja",
          "value": "ja"
        },
        {
          "label": "Nej",
          "value": "nej"
        },
        {
          "label": "Vet ej",
          "value": "vet-ej"
        }
      ],
      "partyAnswers": {
        "socialdemokraterna": {
          "answer": "nej",
          "motivation": ""
        },
        "moderaterna": {
          "answer": "nej",
          "motivation": ""
        },
        "sverigedemokraterna": {
          "answer": "vet-ej",
          "motivation": ""
        },
        "miljopartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "centerpartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "vansterpartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "liberalerna": {
          "answer": "ja",
          "motivation": ""
        },
        "kristdemokraterna": {
          "answer": "nej",
          "motivation": ""
        }
      }
    },
    {
      "id": 3,
      "slug": "forbjud-palsfarmning",
      "image": "/images/questions/mink_hemsk_7_Oikeutta_elaimille.jpg",
      "title": "Förbjud pälsfarmning",
      "description": "De sista svenska minkfarmerna i Sverige har avvecklats, efter långvarigt påverkansarbete från Djurens Rätt, men utan ett förbud i lagen finns det en risk att pälsdjursfarming återkommer. Den svenska djurskyddslagen är tydlig med att djur har rätt till naturligt beteende. Trots det har minkar hållits i trånga gallerburar inom den svenska pälsdjursfarmningen.",
      "proposal": "Förbjud pälsdjursfarming i Sverige.",
      "options": [
        {
          "label": "Ja",
          "value": "ja"
        },
        {
          "label": "Nej",
          "value": "nej"
        },
        {
          "label": "Vet ej",
          "value": "vet-ej"
        }
      ],
      "partyAnswers": {
        "socialdemokraterna": {
          "answer": "vet-ej",
          "motivation": ""
        },
        "moderaterna": {
          "answer": "ja",
          "motivation": ""
        },
        "sverigedemokraterna": {
          "answer": "ja",
          "motivation": ""
        },
        "miljopartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "centerpartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "vansterpartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "liberalerna": {
          "answer": "ja",
          "motivation": ""
        },
        "kristdemokraterna": {
          "answer": "ja",
          "motivation": ""
        }
      }
    },
    {
      "id": 4,
      "slug": "tillsatt-djurskyddsminister",
      "image": "/images/questions/politik_3.jpg",
      "title": "Tillsätt en djurskyddsminister",
      "description": "I Sverige ligger ansvaret för djurskyddsfrågorna på landsbygdsministern; samma minister som ska se till djurfabrikernas ekonomiska intressen. Djurens välfärd kommer därför ofta i andra hand. Att inrätta en djurskyddsminister som kan stå upp för djurskydd och -välfärd skulle vara ett sätt att säkerställa att djurens perspektiv tas till vara och att djurskyddslagstiftningen efterlevs och uppdateras.",
      "proposal": "Inrätta en särskild djurskyddsminister i Sverige, som ansvarar för att bevaka och stärka djurskyddet.",
      "options": [
        {
          "label": "Ja",
          "value": "ja"
        },
        {
          "label": "Nej",
          "value": "nej"
        },
        {
          "label": "Vet ej",
          "value": "vet-ej"
        }
      ],
      "partyAnswers": {
        "socialdemokraterna": {
          "answer": "vet-ej",
          "motivation": ""
        },
        "moderaterna": {
          "answer": "nej",
          "motivation": ""
        },
        "sverigedemokraterna": {
          "answer": "nej",
          "motivation": ""
        },
        "miljopartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "centerpartiet": {
          "answer": "vet-ej",
          "motivation": ""
        },
        "vansterpartiet": {
          "answer": "vet-ej",
          "motivation": ""
        },
        "liberalerna": {
          "answer": "nej",
          "motivation": ""
        },
        "kristdemokraterna": {
          "answer": "nej",
          "motivation": ""
        }
      }
    },
    {
      "id": 5,
      "slug": "stoppa-massdodandet-av-tuppkycklingar",
      "image": "/images/questions/male-chicks-separated-horrible-7.jpg",
      "title": "Stoppa massdödandet av tuppkycklingar ",
      "description": "Hälften av alla kycklingar som kläcks i äggfabrikerna är tuppar. Eftersom tuppkycklingarna inte kommer att lägga några ägg, eller är tillräckligt snabbväxande för lönsam köttproduktion, ses de som svinn och dödas direkt efter att de kläckts. I Sverige rör det sig om ungefär fem miljoner kycklingar per år. Det finns teknik för att könssortera äggen i ett tidigt skede. Då skulle äggen kunna användas eller kasseras i stället.",
      "proposal": "Förbjud avlivning av tuppkycklingar Sverige.",
      "options": [
        {
          "label": "Ja",
          "value": "ja"
        },
        {
          "label": "Nej",
          "value": "nej"
        },
        {
          "label": "Vet ej",
          "value": "vet-ej"
        }
      ],
      "partyAnswers": {
        "socialdemokraterna": {
          "answer": "vet-ej",
          "motivation": ""
        },
        "moderaterna": {
          "answer": "vet-ej",
          "motivation": ""
        },
        "sverigedemokraterna": {
          "answer": "vet-ej",
          "motivation": ""
        },
        "miljopartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "centerpartiet": {
          "answer": "nej",
          "motivation": ""
        },
        "vansterpartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "liberalerna": {
          "answer": "ja",
          "motivation": ""
        },
        "kristdemokraterna": {
          "answer": "nej",
          "motivation": ""
        }
      }
    },
    {
      "id": 6,
      "slug": "främja-djurfri-forskning",
      "image": "/images/questions/djurforsok_beagle.jpg",
      "title": "Främja djurfri forskning ",
      "description": "För att djurfria metoder helt ska kunna ersätta djurförsök behövs forskning. Idag räcker den statliga finansieringen av forskning på området bara till ett fåtal projekt varje år. För att snabba på omställningen bort från omoderna och plågsamma djurförsök behöver Sverige investera i djurfria forsknings- och testmetoder.",
      "proposal": "Höj de statliga anslagen till utveckling av alternativa metoder till djurförsök.",
      "options": [
        {
          "label": "Ja",
          "value": "ja"
        },
        {
          "label": "Nej",
          "value": "nej"
        },
        {
          "label": "Vet ej",
          "value": "vet-ej"
        }
      ],
      "partyAnswers": {
        "socialdemokraterna": {
          "answer": "vet-ej",
          "motivation": ""
        },
        "moderaterna": {
          "answer": "vet-ej",
          "motivation": ""
        },
        "sverigedemokraterna": {
          "answer": "ja",
          "motivation": ""
        },
        "miljopartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "centerpartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "vansterpartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "liberalerna": {
          "answer": "ja",
          "motivation": ""
        },
        "kristdemokraterna": {
          "answer": "vet-ej",
          "motivation": ""
        }
      }
    },
    {
      "id": 7,
      "slug": "stoppa-plagsamma-bedovningsmetoder-vid-slakt",
      "image": "/images/questions/grisar_16.jpg",
      "title": "Stoppa plågsamma bedövningsmetoder vid slakt ",
      "description": "Djur ska enligt lag bedövas innan slakt, men de bedövningsmetoder som används orsakar ofta i sig ett stort lidande. Grisar och fiskar bedövas med koldioxid, trots att metoden orsakar ångest och smärta. Många kycklingar och hönor hängs upp i benen och doppas i elektrifierade vattenbad inför slakt. Det är inte ovanligt att de på grund av det höga tempot får elstötar i vingarna eller råkar skållas levande. ",
      "proposal": "Inför ett slutdatum för användning av plågsamma bedövningsmetoder vid slakt.",
      "options": [
        {
          "label": "Ja",
          "value": "ja"
        },
        {
          "label": "Nej",
          "value": "nej"
        },
        {
          "label": "Vet ej",
          "value": "vet-ej"
        }
      ],
      "partyAnswers": {
        "socialdemokraterna": {
          "answer": "vet-ej",
          "motivation": ""
        },
        "moderaterna": {
          "answer": "nej",
          "motivation": ""
        },
        "sverigedemokraterna": {
          "answer": "nej",
          "motivation": ""
        },
        "miljopartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "centerpartiet": {
          "answer": "nej",
          "motivation": ""
        },
        "vansterpartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "liberalerna": {
          "answer": "ja",
          "motivation": ""
        },
        "kristdemokraterna": {
          "answer": "vet-ej",
          "motivation": ""
        }
      }
    },
    {
      "id": 8,
      "slug": "framja-produktionen-av-vaxbaserad-mat",
      "image": "/images/questions/Vego_8.jpg",
      "title": "Främja produktionen av växtbaserad mat ",
      "description": "Idag används subventioner och andra stöd inom livsmedelsproduktionen nästan uteslutande till djuruppfödning och foderproduktion. Samtidigt tvingas producenter av växtbaserad mat ofta skicka sina råvaror utomlands för förädling, eftersom Sverige har så begränsad kapacitet på området. Stora delar av den svenska djurproduktionen är sårbar för störningar, som kan få långtgående konsekvenser för både livsmedelsproduktionen och djurvälfärden i händelse av kris eller krig. Växtbaserade livsmedel har däremot stor potential med avseende på att stärka landets livsmedelsberedskap.",
      "proposal": "Sätt mål för ökad produktion och förädling av växtbaserad mat i Sverige. ",
      "options": [
        {
          "label": "Ja",
          "value": "ja"
        },
        {
          "label": "Nej",
          "value": "nej"
        },
        {
          "label": "Vet ej",
          "value": "vet-ej"
        }
      ],
      "partyAnswers": {
        "socialdemokraterna": {
          "answer": "ja",
          "motivation": ""
        },
        "moderaterna": {
          "answer": "nej",
          "motivation": ""
        },
        "sverigedemokraterna": {
          "answer": "ja",
          "motivation": ""
        },
        "miljopartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "centerpartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "vansterpartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "liberalerna": {
          "answer": "nej",
          "motivation": ""
        },
        "kristdemokraterna": {
          "answer": "vet-ej",
          "motivation": ""
        }
      }
    },
    {
      "id": 9,
      "slug": "bevara-betesratten-for-kor",
      "image": "/images/questions/Ko_och_kalv_36.jpg",
      "title": "Bevara betesrätten för kor ",
      "description": "Bete är en del av kornas naturliga beteenden och bidrar till fysiskt och psykiskt välmående. Sverige är idag det enda landet i världen där det är lag på att kor ska ges möjlighet att beta utomhus under sommaren. Trots de fördelar som beteskravet har för djurskyddet, föreslår en utredning att kornas rätt till bete slopas, någonting som Djurens Rätt är starkt kritiska till.",
      "proposal": "Lägg ner förslaget om att ta bort beteskravet för kor.",
      "options": [
        {
          "label": "Ja",
          "value": "ja"
        },
        {
          "label": "Nej",
          "value": "nej"
        },
        {
          "label": "Vet ej",
          "value": "vet-ej"
        }
      ],
      "partyAnswers": {
        "socialdemokraterna": {
          "answer": "ja",
          "motivation": ""
        },
        "moderaterna": {
          "answer": "nej",
          "motivation": ""
        },
        "sverigedemokraterna": {
          "answer": "vet-ej",
          "motivation": ""
        },
        "miljopartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "centerpartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "vansterpartiet": {
          "answer": "ja",
          "motivation": ""
        },
        "liberalerna": {
          "answer": "ja",
          "motivation": ""
        },
        "kristdemokraterna": {
          "answer": "nej",
          "motivation": ""
        }
      }
    }
  ]
}
